import { CommandCreateEmployee } from "./commands/CmdCreateEmployee";
import { CommandGetEmployees } from "./commands/CmdGetEmployees";

export class EmployeeService {
  async createEmployee(personId: number, organizationId: number) {
    const cmd = new CommandCreateEmployee();
    const results = await cmd.run(personId, organizationId);
    return results;
  }

  async getEmployees(organizationId: number) {
    const cmd = new CommandGetEmployees();
    const results = await cmd.run(organizationId);
    return results;
  }
}
